import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Calendar from 'react-calendar';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { Calendar as CalendarIcon } from 'lucide-react';
import dayjs from 'dayjs';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const MeetingReschedule = () => {
  const { meetingId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [newTime, setNewTime] = useState(null);

  const handleReschedule = async () => {
    if (!newTime) {
      toast.error('Please select a new time');
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${API}/meetings/action`, {
        meetingId,
        action: 'reschedule',
        newDateTime: newTime
      });

      toast.success('Meeting rescheduled successfully!');
      navigate('/');
    } catch (error) {
      toast.error('Failed to reschedule meeting');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100 flex items-center justify-center py-8 px-4">
      <Card className="max-w-2xl w-full p-8 bg-white shadow-xl">
        <h1 className="text-3xl font-bold text-slate-900 mb-6" style={{fontFamily: 'Space Grotesk, sans-serif'}}>
          Reschedule Meeting
        </h1>

        <div className="mb-6">
          <Label className="block mb-3">Select New Date</Label>
          <Calendar
            onChange={setSelectedDate}
            value={selectedDate}
            minDate={new Date()}
            className="border-0 w-full"
          />
        </div>

        <div className="flex gap-3">
          <Button
            variant="outline"
            onClick={() => navigate('/')}
            className="flex-1"
          >
            Cancel
          </Button>
          <Button
            onClick={handleReschedule}
            disabled={!newTime || loading}
            className="flex-1 bg-slate-900 hover:bg-slate-800 text-white"
          >
            <CalendarIcon className="w-4 h-4 mr-2" />
            {loading ? 'Rescheduling...' : 'Confirm Reschedule'}
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default MeetingReschedule;
